module.exports = __webpack_public_path__ + "img/ipad_jp.808cdec.jpg";